import { cn } from "@holigral/shared/ui/lib/utils"
import { useT } from "@/i18n"

type Props = {
  variant?: "full" | "glyph" | "wordmark"
  size?: string | number
  className?: string
}

export default function Logo({ variant = "full", size, className }: Props) {
  const { t } = useT()
  const style = size
    ? { fontSize: typeof size === "number" ? `${size}px` : size }
    : undefined

  return (
    <span
      className={cn("inline-flex items-center gap-[0.08em]", className)}
      style={style}
    >
      {/* TODO: Emblem goes here */}
      {variant !== "wordmark" && ""}
      {variant !== "glyph" && (
        <span className="font-title text-[1em] leading-none tracking-tight">
          {t("appName")}
        </span>
      )}
    </span>
  )
}
